import {createAction} from 'util/redux';
import {TopNavBarButton} from 'module/TopNavBar/type/TopNavBarButton';

const NAMESPACE = 'TOP_NAV_BAR/'
export const setTopNavBarTitleAction = createAction<string>(NAMESPACE + 'setTitle')
export const setTopNavBarButtonAction = createAction<TopNavBarButton>(NAMESPACE + 'setTopNavBarButton')
